var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 110 110", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", transform: "translate(17 8)" },
      React.createElement("rect", { fillOpacity: ".05", fill: "#191b24", y: "37", width: "73", height: "57", rx: "2" }),
      React.createElement("path", { d: "M5 32.4h70a1 1 0 0 1 1 1V89a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V33.4a1 1 0 0 1 1-1", fill: "#ebba16" }),
      React.createElement("path", { d: "M50.8 57.6c0-5.965-4.835-10.8-10.8-10.8-5.965 0-10.8 4.835-10.8 10.8 0 4.741 3.074 8.726 7.326 10.177-.04.209-.126.403-.126.623v7.2c0 1.987 1.613 3.6 3.6 3.6s3.6-1.613 3.6-3.6v-7.2c0-.22-.086-.414-.126-.623C47.726 66.326 50.8 62.341 50.8 57.6", fill: "#38454f" }),
      React.createElement("path", { d: "M35 7.2c9.925 0 13.896-7.2 0-7.2S9.8 11.304 9.8 25.2v7.2H17v-7.2c0-9.925 8.07-18 18-18", fillOpacity: ".05", fill: "#191b24" }),
      React.createElement("path", { d: "M22 25.2c0-9.925 8.07-18 18-18 9.925 0 18 8.07 18 18v7.2h7.2v-7.2C65.2 11.304 53.896 0 40 0 26.104 0 14.8 11.304 14.8 25.2v7.2H22v-7.2", fill: "#424a60" })
    )
  );
});